import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';

import { AllChatsOverview } from '@/features/chat/all-chats';

const ChatFilterSchema = z.enum([
  'all',
  'favorites',
  'in-project',
  'no-project',
  'from-meeting',
  'archived',
]);

export const Route = createFileRoute('/_authenticated/chats/all')({
  component: AllChatsRoute,
  validateSearch: z.object({
    filter: ChatFilterSchema.optional().catch(undefined),
  }).parse,
});

function AllChatsRoute() {
  const navigate = useNavigate();
  const { filter = 'all' } = Route.useSearch();

  return (
    <AllChatsOverview
      filter={filter}
      onFilterChange={(nextFilter) =>
        navigate({
          to: '/chats/all',
          search: nextFilter === 'all' ? {} : { filter: nextFilter },
          replace: true,
        })
      }
    />
  );
}
